import { handleActions } from 'redux-actions';
import { reset } from 'actions/user';

const initialState: any = null;

const reducer = handleActions(
  {
    [reset as any]: () => null,
  },
  initialState
);

export default reducer;
